function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Profile_svg__cls-2{fill:#c9c9c9}"));
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 426.5,
  cy: 426.5,
  r: 426.5,
  fill: "#fff"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "Profile_svg__cls-2",
  cx: 427,
  cy: 331,
  r: 122
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "Profile_svg__cls-2",
  d: "M426 470c-142.49 0-258 115.51-258 258v33c0 1.61 0 3.2.06 4.8a426.58 426.58 0 00515.87.77c0-1.85.07-3.71.07-5.57v-33c0-142.49-115.51-258-258-258z"
});
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Profile_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 853 853"
  }, props), _ref, _ref2, _ref3, _ref4);
};
export default SvgProfile;